import { useState, useEffect } from "react";

const LOGO =
    "https://customer-assets.emergentagent.com/job_74007a75-e0c2-4452-bdc7-515e3dc56401/artifacts/qxxe8th0_K%20%E2%80%A2TEAM.png";

const PRODUCTS = [
    {
        id: "wmc-album-cover",
        type: "Print",
        name: "Weapon of Mass Creation — Album",
        price: 50,
        artwork:
            "https://customer-assets.emergentagent.com/job_kteam-studio/artifacts/tao0zkwb_Album%20cover.jpg",
        useDirectImage: true,
        flatArt: true,
        hideTypeTag: true,
    },
    {
        id: "wmc-album-tee",
        type: "Tee",
        name: "Weapon of Mass Creation Album Tee",
        price: 40,
        artwork:
            "https://customer-assets.emergentagent.com/job_kteam-studio/artifacts/oamokqz1_Screenshot%202026-06-28%20at%2012.19.13%E2%80%AFPM.png",
        useDirectImage: true,
    },
    {
        id: "flytrap-winged-lady-tee-main",
        type: "Tee",
        name: "Flytrap — Winged Lady",
        price: 40,
        artwork:
            "https://customer-assets.emergentagent.com/job_kteam-studio/artifacts/l48t6v45_WingedLadyTshirtBlack.png",
        useDirectImage: true,
    },
    {
        id: "la-mosca-flyfest-tee",
        type: "Tee",
        name: "La Mosca + Flyfest",
        price: 40,
        artwork:
            "https://customer-assets.emergentagent.com/job_kteam-studio/artifacts/ww5g1g5e_La%20Mosca%20%2B%20Flyfest.png",
        useDirectImage: true,
    },
    {
        id: "revenge-urge-to-fly-tee",
        type: "Tee",
        name: "Revenge and The Urge to Fly",
        price: 40,
        artwork:
            "https://customer-assets.emergentagent.com/job_kteam-studio/artifacts/pda5coaq_Revenge%20and%20The%20Urge%20to%20Fly.png",
        useDirectImage: true,
    },
    {
        id: "legacy-tee",
        type: "Tee",
        name: "Flytrap Legacy",
        price: 40,
        artwork:
            "https://customer-assets.emergentagent.com/job_kteam-studio/artifacts/e96pgzzq_FlytrapLegacy.png",
        useDirectImage: true,
    },
    {
        id: "birds-tote",
        type: "Tote",
        name: "Birds — by SVK",
        price: 20,
        artwork:
            "https://customer-assets.emergentagent.com/job_kteam-studio/artifacts/clpli1w1_Birds.png",
        useDirectImage: true,
    },
    {
        id: "sun-and-people-tote",
        type: "Tote",
        name: "Sun Choir — by SVK",
        price: 20,
        artwork:
            "https://customer-assets.emergentagent.com/wingman/3162c098-bb0d-4e32-977b-94be685460c5/attachments/ed8a1a74558a4aa08a17639473b975a6_NewTote.png",
        useDirectImage: true,
    },
];

const COLORS = [
    { name: "Bone", value: "#F5F2EB", ring: "var(--ink)" },
    { name: "Ink", value: "#1C1B1A", ring: "var(--bg-base)" },
    { name: "Sienna", value: "#B84A39", ring: "var(--bg-base)" },
];

function MockupTee({ product, shirtColor }) {
    // Light shirts -> dark logo; dark shirt -> white logo
    const darkShirt = shirtColor.toLowerCase() === "#1c1b1a";
    const logoFilter = darkShirt
        ? "brightness(0) invert(1)"
        : "brightness(0)";
    return (
        <svg
            viewBox="0 0 400 460"
            className="w-full h-full"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={`tee-mockup-${product.id}`}
        >
            <defs>
                <clipPath id={`clip-${product.id}`}>
                    <rect x="120" y="160" width="160" height="180" />
                </clipPath>
            </defs>
            <path
                d="M70 90 L150 50 Q200 90 250 50 L330 90 L370 170 L300 200 L300 430 Q200 450 100 430 L100 200 L30 170 Z"
                fill="currentColor"
                stroke="rgba(0,0,0,0.15)"
                strokeWidth="1"
            />
            <path
                d="M150 50 Q200 90 250 50"
                fill="none"
                stroke="rgba(0,0,0,0.25)"
                strokeWidth="1.5"
            />
            {product.artwork === "logo" ? (
                <image
                    href={LOGO}
                    x="135"
                    y="150"
                    width="55"
                    height="40"
                    preserveAspectRatio="xMidYMid meet"
                    style={{ filter: logoFilter }}
                />
            ) : (
                <image
                    href={product.artwork}
                    x="120"
                    y="160"
                    width="160"
                    height="180"
                    preserveAspectRatio="xMidYMid meet"
                    clipPath={`url(#clip-${product.id})`}
                />
            )}
        </svg>
    );
}

function MockupTote({ product }) {
    return (
        <svg
            viewBox="0 0 400 460"
            className="w-full h-full"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={`tote-mockup-${product.id}`}
        >
            <defs>
                <clipPath id={`tclip-${product.id}`}>
                    <rect x="105" y="160" width="190" height="220" />
                </clipPath>
            </defs>
            {/* handles */}
            <path
                d="M135 130 Q145 40 200 40 Q255 40 265 130"
                fill="none"
                stroke="currentColor"
                strokeWidth="6"
            />
            {/* body */}
            <rect
                x="85"
                y="125"
                width="230"
                height="280"
                fill="currentColor"
                stroke="rgba(0,0,0,0.2)"
            />
            {product.artwork === "logo" ? (
                <>
                    {/* invisible arc path for K•TEAM lettering */}
                    <defs>
                        <path
                            id={`tote-arc-${product.id}`}
                            d="M 130 280 A 110 70 0 0 1 270 280"
                            fill="none"
                        />
                    </defs>
                    <text
                        fill="#1C1B1A"
                        fontFamily="'IBM Plex Mono', monospace"
                        fontWeight="600"
                        fontSize="18"
                        letterSpacing="6"
                        textAnchor="middle"
                    >
                        <textPath
                            href={`#tote-arc-${product.id}`}
                            startOffset="50%"
                        >
                            K • TEAM
                        </textPath>
                    </text>
                </>
            ) : (
                <image
                    href={product.artwork}
                    x="105"
                    y="160"
                    width="190"
                    height="220"
                    preserveAspectRatio="xMidYMid meet"
                    clipPath={`url(#tclip-${product.id})`}
                />
            )}
        </svg>
    );
}

function DirectTeePhoto({ product }) {
    const isSticker = product.type === "Sticker";
    return (
        <div
            className="relative w-full h-full flex items-center justify-center"
            data-testid={`direct-photo-${product.id}`}
        >
            <img
                src={product.artwork}
                alt={product.name}
                className="object-contain"
                style={
                    isSticker
                        ? { width: "55%", height: "55%" }
                        : {
                              position: "absolute",
                              inset: 0,
                              width: "100%",
                              height: "100%",
                          }
                }
            />
            {product.tieDye && (
                <>
                    {/* Tie-dye conic overlay clipped to roughly the central logo area */}
                    <div
                        aria-hidden
                        className="absolute pointer-events-none"
                        style={{
                            left: "26%",
                            right: "26%",
                            top: "26%",
                            bottom: "30%",
                            background:
                                "conic-gradient(from 140deg at 50% 50%, #ff3b9a, #ffd24a, #4ad8ff, #b04bff, #ff6a3d, #ff3b9a)",
                            mixBlendMode: "screen",
                            filter: "blur(6px) saturate(1.15)",
                            opacity: 0.92,
                        }}
                    />
                    <div
                        aria-hidden
                        className="absolute pointer-events-none"
                        style={{
                            left: "26%",
                            right: "26%",
                            top: "26%",
                            bottom: "30%",
                            background:
                                "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.18), transparent 60%)",
                            mixBlendMode: "overlay",
                        }}
                    />
                </>
            )}
            {product.purpleTint && (
                <div
                    aria-hidden
                    className="absolute pointer-events-none"
                    style={{
                        left: "26%",
                        right: "26%",
                        top: "26%",
                        bottom: "30%",
                        background: "#8B3FE0",
                        mixBlendMode: "multiply",
                        opacity: 1,
                    }}
                />
            )}
        </div>
    );
}

function MockupSticker({ product }) {
    return (
        <div
            className="relative w-full h-full flex items-center justify-center p-6 md:p-10"
            data-testid={`sticker-mockup-${product.id}`}
        >
            <div
                className="relative rounded-full overflow-hidden"
                style={{
                    width: "78%",
                    aspectRatio: "1 / 1",
                    background: "#000",
                    boxShadow:
                        "0 12px 36px -8px rgba(0,0,0,0.45), inset 0 0 0 6px rgba(255,255,255,0.04)",
                }}
            >
                <img
                    src={product.artwork}
                    alt={product.name}
                    className="absolute inset-0 w-full h-full object-cover"
                    style={{ transform: "scale(1.85)" }}
                />
                <div
                    aria-hidden
                    className="absolute inset-0 rounded-full"
                    style={{
                        boxShadow:
                            "inset 0 0 0 2px rgba(255,255,255,0.06), inset 0 -30px 60px rgba(0,0,0,0.55)",
                    }}
                />
            </div>
        </div>
    );
}

function ProductCard({ product, index, onOpen, onReserve }) {
    return (
        <article
            data-testid={`product-card-${product.id}`}
            className="group flex flex-col rise"
            style={{ animationDelay: `${80 + index * 80}ms` }}
        >
            <button
                type="button"
                onClick={() => onOpen(product)}
                data-testid={`product-open-${product.id}`}
                aria-label={`Open larger view of ${product.name}`}
                className="relative aspect-[4/5] border border-[var(--ink)]/20 overflow-hidden block w-full text-left cursor-zoom-in"
                style={{ background: "var(--bg-paper)" }}
            >
                <div
                    className="absolute inset-0 flex items-center justify-center transition-transform duration-700 group-hover:scale-[1.4]"
                    style={{
                        color:
                            product.type === "Tote" ||
                            product.type === "Sticker"
                                ? "#EFEAD9"
                                : "#F5F2EB",
                    }}
                >
                    {product.useDirectImage ? (
                        <DirectTeePhoto product={product} />
                    ) : product.type === "Sticker" ? (
                        <MockupSticker product={product} />
                    ) : product.type === "Tee" ? (
                        <MockupTee
                            product={product}
                            shirtColor={"#F5F2EB"}
                        />
                    ) : (
                        <MockupTote product={product} />
                    )}
                </div>

                {!product.hideTypeTag && (
                    <span className="absolute top-3 left-3 font-mono-acc text-[10px] tracking-[0.32em] uppercase px-2 py-1 bg-[var(--bg-base)] text-[var(--ink)] border border-[var(--ink)]/30">
                        {product.type}
                    </span>
                )}
                <span className="absolute top-3 right-3 font-mono-acc text-[10px] tracking-[0.32em] uppercase px-2 py-1 bg-[var(--ink)] text-[var(--bg-base)]">
                    No. {String(index + 1).padStart(2, "0")}
                </span>
                {product.placeholder && (
                    <span className="absolute bottom-3 left-3 font-mono-acc text-[10px] tracking-[0.32em] uppercase px-2 py-1 bg-[var(--ochre)] text-[var(--ink)]">
                        Artwork pending
                    </span>
                )}
                <span
                    aria-hidden
                    className="absolute bottom-3 right-3 font-mono-acc text-[10px] tracking-[0.32em] uppercase px-2 py-1 bg-[var(--ink)]/75 text-[var(--bg-base)] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                >
                    View larger ↗
                </span>
            </button>

            <div className="mt-5 flex items-start justify-between gap-4">
                <h3 className="font-serif-display text-2xl md:text-3xl leading-tight tracking-tight">
                    {product.name}
                </h3>
                <p className="font-serif-display text-2xl md:text-3xl text-[var(--sienna)] whitespace-nowrap">
                    ${product.price}
                </p>
            </div>
        </article>
    );
}

function ProductLightbox({ product, onClose }) {
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [onClose]);

    if (!product) return null;
    return (
        <div
            data-testid="shop-lightbox"
            className="fixed inset-0 z-[80] flex items-center justify-center p-4 md:p-10"
            style={{ background: "rgba(20,18,16,0.92)" }}
            onClick={onClose}
        >
            <button
                type="button"
                onClick={onClose}
                data-testid="shop-lightbox-close"
                aria-label="Close"
                className="absolute top-5 right-5 md:top-8 md:right-8 font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)] border border-[var(--bg-base)]/40 px-3 py-2 hover:bg-[var(--bg-base)] hover:text-[var(--ink)] transition-colors z-10"
            >
                Close ✕
            </button>
            <div
                className="w-full flex flex-col items-center"
                style={{ maxWidth: "min(1400px, 95vw)" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="mb-4 md:mb-6 flex items-end justify-between w-full gap-6">
                    <div>
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--ochre)]">
                            {product.type}
                        </p>
                        <h3 className="mt-1 font-serif-display text-3xl md:text-5xl tracking-tight text-[var(--bg-base)]">
                            {product.name}
                        </h3>
                    </div>
                    <p className="font-serif-display text-3xl md:text-4xl text-[var(--ochre)] whitespace-nowrap">
                        ${product.price}
                    </p>
                </div>
                <div className="relative w-full bg-[var(--bg-paper)] border border-[var(--bg-base)]/20 flex items-center justify-center p-4 md:p-8">
                    <img
                        src={product.artwork}
                        alt={product.name}
                        className="block object-contain"
                        style={{
                            maxHeight: "82vh",
                            maxWidth: "100%",
                            width: "auto",
                            height: "auto",
                        }}
                    />
                </div>
                <p className="mt-4 font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)]/55">
                    Order by e-transfer to connect@hellokteam.com
                </p>
            </div>
        </div>
    );
}

function OrderForm({ product, onClose }) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [size, setSize] = useState(product.type === "Tee" ? "M" : "One Size");
    const [qty, setQty] = useState(1);
    const [notes, setNotes] = useState("");
    const [status, setStatus] = useState("idle"); // idle | sending | success | error
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [onClose]);

    const sizes =
        product.type === "Tee" ? ["XS", "S", "M", "L", "XL"] : ["One Size"];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (status === "sending") return;
        setStatus("sending");
        setErrorMsg("");

        const payload = {
            _subject: `K-Team Order — ${product.name}`,
            _captcha: "false",
            _template: "table",
            product: product.name,
            type: product.type,
            price: `$${product.price}`,
            size,
            quantity: qty,
            full_name: name,
            email,
            shipping_address: address,
            notes: notes || "(none)",
            payment_method: "E-transfer to connect@hellokteam.com",
            shipping_note: "4–8+ business days once payment received",
        };

        try {
            const res = await fetch(
                "https://formsubmit.co/ajax/connect@hellokteam.com",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );
            if (!res.ok) {
                throw new Error(`Submission failed (${res.status})`);
            }
            const data = await res.json().catch(() => ({}));
            if (data && data.success === "false") {
                throw new Error(data.message || "Submission failed");
            }
            setStatus("success");
        } catch (err) {
            setStatus("error");
            setErrorMsg(
                err && err.message
                    ? err.message
                    : "Could not send order — please try again or email connect@hellokteam.com directly."
            );
        }
    };

    const fieldCls =
        "w-full bg-transparent border border-[var(--bg-base)]/30 px-3 py-2 text-[var(--bg-base)] placeholder:text-[var(--bg-base)]/40 focus:outline-none focus:border-[var(--ochre)] focus:bg-[var(--bg-base)]/5 font-body text-sm";
    const labelCls =
        "block font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)]/60 mb-1";

    return (
        <div
            data-testid="order-form-modal"
            className="fixed inset-0 z-[90] flex items-center justify-center p-4 md:p-10 overflow-y-auto"
            style={{ background: "rgba(20,18,16,0.94)" }}
            onClick={onClose}
        >
            <button
                type="button"
                onClick={onClose}
                data-testid="order-form-close"
                aria-label="Close"
                className="absolute top-5 right-5 md:top-8 md:right-8 font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)] border border-[var(--bg-base)]/40 px-3 py-2 hover:bg-[var(--bg-base)] hover:text-[var(--ink)] transition-colors z-10"
            >
                Close ✕
            </button>
            {status === "success" ? (
                <div
                    onClick={(e) => e.stopPropagation()}
                    data-testid="of-success"
                    className="w-full max-w-2xl my-10 bg-[var(--ink)] border border-[var(--ochre)] p-8 md:p-12 text-center"
                >
                    <div
                        aria-hidden
                        className="mx-auto mb-6 flex items-center justify-center w-16 h-16 rounded-full border border-[var(--ochre)] text-[var(--ochre)]"
                    >
                        <svg
                            viewBox="0 0 24 24"
                            width="28"
                            height="28"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M5 12l4 4L19 7" />
                        </svg>
                    </div>
                    <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--ochre)]">
                        Reservation received
                    </p>
                    <h3 className="mt-3 font-serif-display text-3xl md:text-5xl tracking-tight text-[var(--bg-base)] leading-tight">
                        Thank you, {name.split(" ")[0] || "friend"}.
                    </h3>
                    <p className="mt-5 font-body text-sm md:text-base text-[var(--bg-base)]/80 leading-relaxed max-w-md mx-auto">
                        Your order for{" "}
                        <span className="italic">{product.name}</span> is on
                        our table. We&rsquo;ll confirm at{" "}
                        <span className="text-[var(--bg-base)]">
                            {email}
                        </span>{" "}
                        and send e-transfer details shortly. Shipping takes
                        4–8+ business days once payment is received.
                    </p>
                    <button
                        type="button"
                        onClick={onClose}
                        data-testid="of-success-close"
                        className="mt-8 font-mono-acc text-[10px] tracking-[0.32em] uppercase px-5 py-3 bg-[var(--ochre)] text-[var(--ink)] hover:bg-[var(--bg-base)] transition-colors"
                    >
                        Close
                    </button>
                </div>
            ) : (
                <form
                    onSubmit={handleSubmit}
                    onClick={(e) => e.stopPropagation()}
                    className="w-full max-w-3xl my-10 grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-6"
                >
                <div className="md:col-span-12">
                    <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--ochre)]">
                        Reserve · {product.type}
                    </p>
                    <h3 className="mt-2 font-serif-display text-3xl md:text-5xl tracking-tight text-[var(--bg-base)]">
                        {product.name}{" "}
                        <span className="text-[var(--ochre)]">
                            · ${product.price}
                        </span>
                    </h3>
                </div>

                <div className="md:col-span-7">
                    <label className={labelCls} htmlFor="of-name">
                        Full Name
                    </label>
                    <input
                        id="of-name"
                        data-testid="of-name"
                        required
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className={fieldCls}
                        placeholder="Your Name"
                    />
                </div>

                <div className="md:col-span-5">
                    <label className={labelCls} htmlFor="of-email">
                        Email Address
                    </label>
                    <input
                        id="of-email"
                        data-testid="of-email"
                        required
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={fieldCls}
                        placeholder="you@example.com"
                    />
                </div>

                <div className="md:col-span-12">
                    <label className={labelCls} htmlFor="of-address">
                        Shipping Address
                    </label>
                    <textarea
                        id="of-address"
                        data-testid="of-address"
                        required
                        rows={3}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        className={fieldCls}
                        placeholder="Street, city, postal/zip, country"
                    />
                </div>

                <div className="md:col-span-8">
                    <label className={labelCls}>Size</label>
                    <div className="flex flex-wrap gap-2">
                        {sizes.map((s) => (
                            <button
                                key={s}
                                type="button"
                                onClick={() => setSize(s)}
                                data-testid={`of-size-${s.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`font-mono-acc text-xs tracking-[0.22em] uppercase px-4 py-2.5 border-2 transition-colors font-semibold min-w-[3rem] ${
                                    size === s
                                        ? "bg-[var(--ochre)] text-[var(--ink)] border-[var(--ochre)]"
                                        : "bg-[var(--bg-base)] text-[var(--ink)] border-[var(--bg-base)] hover:bg-[var(--ochre)] hover:border-[var(--ochre)]"
                                }`}
                            >
                                {s}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="md:col-span-4">
                    <label className={labelCls} htmlFor="of-qty">
                        Quantity
                    </label>
                    <input
                        id="of-qty"
                        data-testid="of-qty"
                        type="number"
                        min={1}
                        max={20}
                        value={qty}
                        onChange={(e) =>
                            setQty(Math.max(1, parseInt(e.target.value) || 1))
                        }
                        className={fieldCls}
                    />
                </div>

                <div className="md:col-span-12 mt-2 border border-[var(--ochre)]/40 bg-[var(--ochre)]/5 p-4 md:p-5">
                    <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--ochre)] mb-2">
                        Payment &amp; shipping
                    </p>
                    <p className="font-body text-sm text-[var(--bg-base)]/85 leading-relaxed">
                        Pay by{" "}
                        <strong className="text-[var(--bg-base)]">
                            e-transfer to connect@hellokteam.com
                        </strong>{" "}
                        using your email address as the reference. Once we
                        receive payment we&rsquo;ll start your order — shipping
                        takes 4–8+ business days.
                    </p>
                </div>

                <div className="md:col-span-12 mt-2 flex flex-wrap gap-3 items-center justify-end">
                    <button
                        type="button"
                        onClick={onClose}
                        data-testid="of-cancel"
                        className="font-mono-acc text-[10px] tracking-[0.32em] uppercase px-4 py-3 border border-[var(--bg-base)]/30 text-[var(--bg-base)]/80 hover:border-[var(--bg-base)] hover:text-[var(--bg-base)] transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={status === "sending"}
                        data-testid="of-submit"
                        className="font-mono-acc text-[10px] tracking-[0.32em] uppercase px-5 py-3 bg-[var(--ochre)] text-[var(--ink)] hover:bg-[var(--bg-base)] transition-colors disabled:opacity-60 disabled:cursor-wait"
                    >
                        {status === "sending"
                            ? "Sending…"
                            : "Send reservation →"}
                    </button>
                </div>

                {status === "error" && (
                    <div
                        className="md:col-span-12 mt-2 border border-[var(--sienna)] bg-[var(--sienna)]/15 p-4"
                        data-testid="of-error"
                    >
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--sienna)] mb-1">
                            Couldn&rsquo;t send
                        </p>
                        <p className="font-body text-sm text-[var(--bg-base)]/85">
                            {errorMsg}
                        </p>
                    </div>
                )}
            </form>
            )}
        </div>
    );
}

export default function Shop() {
    const [active, setActive] = useState(null);
    const [orderProduct, setOrderProduct] = useState(null);
    return (
        <div data-testid="shop-page" className="pt-28 md:pt-36 pb-24">
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
                {/* Header */}
                <div className="grid grid-cols-12 gap-y-6 md:gap-x-10 items-end mb-16 md:mb-24 rise">
                    <div className="col-span-12 md:col-span-8">
                        <p className="font-mono-acc text-[11px] tracking-[0.32em] uppercase text-[var(--sienna)]">
                            § Shop / Editions
                        </p>
                        <h1 className="mt-6 font-serif-display text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-[-0.03em]">
                            The Shop.
                        </h1>
                    </div>
                    <div className="col-span-12 md:col-span-4 md:pb-4 space-y-4">
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)]">
                            Order by e-transfer to connect@hellokteam.com
                        </p>
                    </div>
                </div>

                {/* Grid */}
                <div
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-x-10 md:gap-y-20"
                    data-testid="shop-grid"
                >
                    {PRODUCTS.map((p, i) => (
                        <ProductCard
                            key={p.id}
                            product={p}
                            index={i}
                            onOpen={setActive}
                            onReserve={setOrderProduct}
                        />
                    ))}
                </div>

                {/* Contact strip */}
                <div className="mt-32 md:mt-40 border-t border-[var(--ink)]/15 pt-12 grid grid-cols-12 gap-y-8 md:gap-x-10 items-start">
                    <div className="col-span-12 md:col-span-12 md:text-right">
                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)]">
                            Place an order
                        </p>
                        <div className="mt-3 space-y-2">
                            <a
                                href="mailto:connect@hellokteam.com"
                                data-testid="shop-contact-hello"
                                className="block font-serif-display text-2xl md:text-3xl underline decoration-[var(--ochre)] decoration-2 underline-offset-8 hover:text-[var(--sienna)] transition-colors"
                            >
                                connect@hellokteam.com
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {active && (
                <ProductLightbox
                    product={active}
                    onClose={() => setActive(null)}
                />
            )}
            {orderProduct && (
                <OrderForm
                    product={orderProduct}
                    onClose={() => setOrderProduct(null)}
                />
            )}
        </div>
    );
}

